import React from "react";
import TimeAgo from "react-timeago";
import { NavLink } from "react-router-dom";
import CountDownNow from "react-countdown-now";
import { cleanDate } from "../../../util/app";

const ListView = ({ items = [] }) => {
    if (items.length < 1)
        return (
            <div className="card">
                <div className="card-body" style={{ minHeight: "540px", paddingTop: "10em" }}>
                    <div className="text-center text-pink">
                        <i className="material-icons" style={{ fontSize: "4em" }}>
                            info
                        </i>
                        <br />
                        <strong>No Rota has been added yet</strong>
                    </div>
                </div>
            </div>
        );
    return (
        <div>
            {items.map((i, key) => (
                <div key={key}>
                    <h4 className="text-primary">
                        {cleanDate(i.key.date.start, true, false)}
                        <small>
                            {" "}
                            <TimeAgo date={new Date(i.key.date.start)} />
                        </small>
                    </h4>

                    <h5 className="uppercase">
                        {i.key.period.name}{" "}
                        <span className="badge badge-primary">
                            <CountDownNow date={new Date(i.key.date.end)} />
                        </span>
                    </h5>
                    <div className="row">
                        {i.assignees.map(s => (
                            <div key={s.staff.id} className="col-lg-3 col-md-4 col-sm-6 col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="profile-userpic">
                                                <center>
                                                    <div
                                                        style={{
                                                            backgroundImage: `url(${s.staff.image || `https://dummyimage.com/100x100&text=${s.staff.surname}`})`,
                                                            width: "100px",
                                                            height: "100px"
                                                        }}
                                                        className="img-container margin-top-20 user-img-circle"
                                                    ></div>
                                                </center>
                                            </div>
                                        </div>
                                        <div className="profile-usertitle">
                                            <div className="profile-usertitle-name">
                                                {s.staff.first_name} {s.staff.surname} {s.staff.middle_name ? s.staff.middle_name : ""}
                                            </div>
                                            <div className="profile-usertitle-job">
                                                {s.staff.type.name} | {s.staff.designation.name}{" "}
                                            </div>
                                            <div className="profile-usertitle-job">{s.staff.email}</div>
                                        </div>
                                        <center>
                                            <ul className="list-group list-group-unbordered">
                                                <li className="list-group-item">
                                                    <b>Department</b> <br />
                                                    <a>{s.staff.department.name}</a>
                                                </li>
                                            </ul>
                                        </center>
                                    </div>
                                    <div className="card-footer text-center">
                                        <NavLink
                                            className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-default"
                                            to={{
                                                pathname: "/home/staffing/profile",
                                                search: `?ref=${s.staff.id}`
                                            }}
                                        >
                                            Goto Profile <i className="material-icons text-success">verified_user</i>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ListView;
